import { Controller } from "@hotwired/stimulus"
import { formatProduct } from "../lib/number_format"

// Fills the result input with the product of the factor inputs (times an
// optional multiplier), e.g. quantity × unit price, or bonus × tax rate.
// With an "auto" checkbox the result is computed only while it is checked,
// and is read-only then.
export default class extends Controller {
  static targets = ["factor", "result", "auto"]
  static values = { multiplier: { type: Number, default: 1 } }

  compute() {
    if (this.hasAutoTarget && !this.autoTarget.checked) return

    const factors = this.factorTargets.map((input) => input.value)
    this.resultTarget.value = formatProduct(...factors, this.multiplierValue)
  }

  toggle() {
    this.resultTarget.readOnly = this.autoTarget.checked
    this.compute()
  }
}
